import { UseMutationResult, useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

import { AddressPoint, addressPointFragment } from './useAddressPointApi'

export interface UpdateAddressPointResult {
  addressPoint: AddressPoint | null
  errors: { field: string; message: string }[]
  message: string
  success: boolean
}

export interface UpdateAddressPointInput {
  address1?: string
  address2?: string
  attentionName?: string
  city?: string
  companyName?: string
  countryCode?: string
  facilityId?: string
  firstName?: string
  id: string
  lastName?: string
  phoneNumber?: string
  state?: string
  zip?: string
}

export const useUpdateAddressPointApi = (): UseMutationResult<
  UpdateAddressPointResult,
  Error,
  UpdateAddressPointInput
> => {
  const client = useGraphQLClient()

  const query = gql`
    mutation UpdateAddressPoint($input: UpdateAddressPointInput!) {
      updateAddressPoint(input: $input) {
        addressPoint {
          ...addressPoint
        }
        errors {
          field
          message
        }
        message
        success
      }
    }
    ${addressPointFragment}
  `

  const mutationFn = (input: UpdateAddressPointInput): Promise<UpdateAddressPointResult> =>
    client
      .request<{ updateAddressPoint: UpdateAddressPointResult }>(query, { input })
      .then(({ updateAddressPoint }) => updateAddressPoint)

  return useMutation<UpdateAddressPointResult, Error, UpdateAddressPointInput>({ mutationFn })
}
